import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { snakeToCamelTemplateLiterals } from '@/common/converter/utils/snake-to-camel'
import { EVENT_TYPE } from '@/common/resources/const'

/**
 * 각 셀의 이벤트에 있는 카탈로그 참조 string (`${}`) 을 반환
 * @param event
 * @param context
 * @returns {{type: *, bodylist: *, url: *, contentid: *, content
 */
export const convertCellEvent = (event = {}, context = {}) => {
  const { url, bodylist, contenttype, contentid, type, ...rest } = event
  const camelCaseUrl = snakeToCamelTemplateLiterals(url)

  // get converted body-list
  const processBodyList = (bodyList) =>
    bodyList?.map((body) =>
      replacePlaceholder(snakeToCamelTemplateLiterals(body), context),
    )

  // get content id and type
  const processContent = (content) =>
    replacePlaceholder(snakeToCamelTemplateLiterals(content), context)

  // event type is on-instant play
  if (type === EVENT_TYPE.ON_INSTANT_PLAY) {
    return {
      type,
      bodylist: processBodyList(bodylist),
      contentid: processContent(contentid).replace(/contentid=/gi, ''),
      contenttype: processContent(contenttype),
      ...rest,
    }
  }

  return {
    type,
    bodylist: processBodyList(bodylist),
    url: processContent(camelCaseUrl),
    ...rest,
  }
}
